import { Link } from 'react-router-dom';
import Logo from '../assets/images/Logo.svg';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ichecAndAcc from '../assets/images/Ichec_acc_computer.svg';

function PfasIchecProject() {
  return (
    <>
      {' '}
      <div className='navigation'>
        <div className='logo'>
          <img src={Logo} alt='Quantum logo' />
        </div>
        <div className='nav'>
          <Link to='/pfasdestruction' className='pfas-btn-white-back'>
            <div className='nav-text-back'>Previous</div>
          </Link>
          <Link to='/'>
            <div className='nav-home'></div>
          </Link>

          <div className='nav-page-nr'>6/6</div>

          <Link to='/molecules' className='pfas-btn-blue-next'>
            <div className='nav-text-next'>Next</div>
          </Link>
        </div>
      </div>
      <div className='pfas-ichec pfas-container'>
        <Row>
          <div className='ichec-project'>
            <Col xs={12} lg={6}>

            <div className='text-left'>
              <div className='slogan'>Molecular simulation</div>
              <div className='headline'>ICHEC QPFAS PROJECT</div>
              <div className='text'>
                Our experiments provide the{' '}
                <b>ground state energy of small molecules</b>
                including some which have the{' '}
                <b>same chemical bonds as those found in PFAS</b>. These results
                show how a quantum computer can potentially help in
                understanding the breakdown of PFAS molecules.
              </div>
              <div className='text'>
                Over time, we aim to <b>scale up</b> this project by running
                similar calculations on <b>larger molecules</b>, such as those
                PFAS compounds which are typically found polluting our
                environment.
              </div>
              <div className='text'>
                This project is a collaboration between <b>Accenture</b> and the{' '}
                <b>Irish Centre for High-End Computing (ICHEC)</b>. We created
                the open-source repository:
                <br />
                <b>
                  <a href='https://github.com/ICHEC/QPFAS'>
                    ICHEC Quantum PFAS Chemicals Remediation (QPFAS) toolkit
                  </a>
                </b>
                <br />
                We are working with <b>IonQ</b> on the integration of this
                toolkit with their <b>trapped ion quantum computer</b>.
              </div>
              <Link to='/molecules'>
                <button className='pfas-btn-blue'>Start simulation</button>
              </Link>
            </div>
            </Col>
            <Col xs={12} lg={6}>

            <div className='image-right'>
              <div className='ichec-image'>
                <img
                  src={ichecAndAcc}
                  alt='Ichec and Accenture collaboration'
                />
              </div>
            </div>
            </Col>
          </div>
        </Row>
      </div>
    </>
  );
}

export default PfasIchecProject;
